/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Done_Title_FailedInputs */

const cs_import_done_title_failed = /** @type {(inputs: Import_Done_Title_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import selhal`)
};

const en_import_done_title_failed = /** @type {(inputs: Import_Done_Title_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import failed`)
};

/**
* | output |
* | --- |
* | "Import failed" |
*
* @param {Import_Done_Title_FailedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const import_done_title_failed = /** @type {((inputs?: Import_Done_Title_FailedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Done_Title_FailedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_import_done_title_failed(inputs)
	return cs_import_done_title_failed(inputs)
});